import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';

interface Props {
  index: number;
  prompt: string;
  options: string[];
  isRequired: boolean;
}

const MultipleSelection = ({ index, prompt, options, isRequired }: Props): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />
      <StyledSelect>
        <option value={''}></option>
        {options.map((option, optionIndex) => {
          return (
            <option key={`multiple-selection-options-preview-${optionIndex}`} value={option}>
              {option}
            </option>
          );
        })}
      </StyledSelect>
    </QuestionWrapper>
  );
};

export default MultipleSelection;

const StyledSelect = styled.select`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  font-size: 1em;

  border-radius: 7px;
  border: solid 1px #d2d2d2;
`;
